import { api } from './http'

export function getComments(articleID, page = 1, size = 10) {
  return api.get(`/front/articles/${articleID}/comments`, {
    params: { page, size }
  })
}

export function createComment(articleID, content, parentID = 0) {
  return api.post(`/front/articles/${articleID}/comments`, {
    content,
    parent_id: parentID
  })
}

export function getAdminComments(page = 1, size = 10, keyword = '', articleId = 0, userId = 0) {
  return api.get('/admin/comments', {
    params: { page, size, keyword, article_id: articleId, user_id: userId }
  })
}

export function deleteComment(id) {
  return api.delete(`/admin/comments/${id}`)
}
